import { useCallback } from 'react';
import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { getField } from './schemaUtils.esm.js';

var buildEventMetadata = function buildEventMetadata(values, validationResult, fieldName, fieldSchema, nestedFormEvent, nextValue) {
  return {
    fieldName: fieldName,
    fieldSchema: fieldSchema,
    values: values,
    validationResult: validationResult,
    nestedFormEvent: nestedFormEvent,
    nextValue: nextValue
  };
};
var useGetPropsForField = function useGetPropsForField(props, mapError) {
  if (mapError === void 0) {
    mapError = function mapError(error) {
      return error;
    };
  }

  var values = props.values,
      _props$validationResu = props.validationResult,
      validationResult = _props$validationResu === void 0 ? [false, {}] : _props$validationResu,
      _props$touched = props.touched,
      touched = _props$touched === void 0 ? {} : _props$touched,
      _props$visited = props.visited,
      visited = _props$visited === void 0 ? {} : _props$visited,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      _props$onFieldBlur = props.onFieldBlur,
      onFieldBlur = _props$onFieldBlur === void 0 ? function () {} : _props$onFieldBlur,
      _props$onFieldFocus = props.onFieldFocus,
      onFieldFocus = _props$onFieldFocus === void 0 ? function () {} : _props$onFieldFocus,
      _props$onFieldTouched = props.onFieldTouchedChange,
      onFieldTouchedChange = _props$onFieldTouched === void 0 ? function () {} : _props$onFieldTouched,
      _props$onFieldVisited = props.onFieldVisitedChange,
      onFieldVisitedChange = _props$onFieldVisited === void 0 ? function () {} : _props$onFieldVisited;
  var makeOnFieldChange = useCallback(function (_ref) {
    var name = _ref[0],
        field = _ref[1];
    return function (nextValue) {
      return onChange(buildEventMetadata(values, validationResult, name, field, undefined, nextValue), function (values) {
        var _extends2;

        return _extends({}, values, (_extends2 = {}, _extends2[name] = nextValue, _extends2));
      });
    };
  }, [values, validationResult, onChange]);
  var makeOnFieldFocus = useCallback(function (_ref2) {
    var name = _ref2[0],
        field = _ref2[1];
    return function () {
      var eventMetadata = buildEventMetadata(values, validationResult, name, field); // Call the `onFieldVisitedChange` callback if the field was not visited before.

      if (!visited[name]) {
        onFieldVisitedChange(eventMetadata, function (visited) {
          var _extends3;

          return _extends({}, visited, (_extends3 = {}, _extends3[name] = true, _extends3));
        });
      }

      return onFieldFocus(eventMetadata);
    };
  }, [values, validationResult, visited, onFieldFocus, onFieldVisitedChange]);
  var makeOnFieldBlur = useCallback(function (_ref3) {
    var name = _ref3[0],
        field = _ref3[1];
    return function () {
      var eventMetadata = buildEventMetadata(values, validationResult, name, field); // Call the `onFieldTouchedChange` callback the first time the field is touched.

      if (!touched[name]) {
        onFieldTouchedChange(eventMetadata, function (touched) {
          var _extends4;

          return _extends({}, touched, (_extends4 = {}, _extends4[name] = true, _extends4));
        });
      }

      return onFieldBlur(eventMetadata);
    };
  }, [values, validationResult, touched, onFieldBlur, onFieldTouchedChange]);
  return useCallback(function (name) {
    var field = getField(props.schema, name);
    return {
      name: name,
      value: values[name],
      error: mapError(validationResult[1][name][1]),
      onChange: makeOnFieldChange([name, field]),
      onFocus: makeOnFieldFocus([name, field]),
      onBlur: makeOnFieldBlur([name, field])
    };
  }, [props.schema, values, validationResult, makeOnFieldChange, makeOnFieldFocus, makeOnFieldBlur]);
};

export default useGetPropsForField;
export { buildEventMetadata, useGetPropsForField };
//# sourceMappingURL=useGetPropsForField.esm.js.map
